import { Box, Flex, Heading } from "@chakra-ui/react";
import { MappersTable } from "../../components/mappers-table/mappers-table.comp";

export function MapperList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Mappers</Heading>
            </Flex>
            <MappersTable />
        </Box>
    );
}
